<template>
  <title-container title="Payment Methods" icon="money-check-alt">
    <b-row>
      <b-col class="mt-3">
        <filter-table
          primary-key="id"
          empty-text="No payment methods."
          :fields="fields"
          :items="items"
          :clickable="true"
          :slots="templates"
          @row-clicked="displayItem"
        >
          <template slot="header">
            <div class="float-right ml-2">
              <verification-user-email
                ref="verificationUserAlert"
                placement="bottomleft"
                :target="newItemBtnId"
              />
              <b-dropdown
                :id="newItemBtnId"
                text="+ New Payment Method"
                class="dropdown-anchor raised"
              >
                <b-dropdown-item @click="newItemHandler('ACH')">ACH Payment</b-dropdown-item>
                <b-dropdown-item @click="newItemHandler('Draw')">Draw Payment</b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="text-right">
              <dashboard-button />
            </div>
          </template>
          <template slot="method" slot-scope="record">
              {{ record.value|capitalize }}
          </template>
        </filter-table>
      </b-col>
    </b-row>
    <b-modal
      :id="detailsModalId"
      header-class="anchor-modal"
      ref="paymentMehtodDetailsModal"
      title="Payment Method Details"
      size="lg"
      hide-footer
    >
      <payment-method-display
        v-if="selected"
        class="pm-details"
        :payment-method="selected"
      />
    </b-modal>
    <payment-method-create-modal
      ref="createPaymentMethodModal"
      :show-account-type-field="showAccountTypeField"
      :show-option-field="showOptionField"
      :payment-method-type="paymentMethodType"
    />
  </title-container>
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons';

import DashboardButton from '@/components/utils/buttons/navigation/DashboardButton';
import FilterTable from '@/components/utils/FilterTable';
import PaymentMethodDisplay from '@/components/payments/display/PaymentMethodDisplay';
import PaymentMethodCreateModal from '@/components/payments/create/PaymentMethodCreateModal';
import TitleContainer from '@/components/utils/TitleContainer';
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';


library.add(faMoneyCheckAlt);


export default {
  components: {
    DashboardButton,
    FilterTable,
    PaymentMethodDisplay,
    PaymentMethodCreateModal,
    TitleContainer,
    VerificationUserEmail,
  },
  data: () => ({
    detailsModalId: 'payment-method-details-modal',
    newItemBtnId: 'new-payment-method-btn',
    fields: [
      { key: 'name', sortable: true },
      { key: 'method', sortable: true },
      { key: 'created', label: 'Created Date', sortable: true },
    ],
    templates: [
      { key: 'method' },
    ],
    selected: null,
    showAccountTypeField: true,
    showOptionField: false,
    paymentMethodType: '',
  }),
  computed: {
    items() {
      return this.$store.getters.paymentMethods;
    },
  },
  methods: {
    displayItem(paymentMethod) {
      this.selected = paymentMethod;
      this.$refs.paymentMehtodDetailsModal.show();
    },
    newItemHandler(paymentMethod) {
      if (!this.$refs.verificationUserAlert.isVerified) { return; }
      if (paymentMethod === 'ACH') {
        this.showAccountTypeField = true;
      } else if (paymentMethod === 'Draw') {
        this.showAccountTypeField = false;
      }
      this.paymentMethodType = paymentMethod;
      this.$refs.createPaymentMethodModal.show();
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (this.detailsModalId === modalId) {
        this.selected = null;
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payments/PaymentMethodsList.vue